import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Update a Driver.
 *
 * @private
 */
export const updateDriver = createAsyncThunk<
  // Return type of the payload creator
  void,
  // First argument to the payload creator
  uui.domain.client.rm.Driver,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/driver/update', async (driver, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/driver/update', {
      category: 'rpc',
      type: 'rpc/driver/update',
      driver,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {updateDriver}`,
      { tags: ['rpc', 'driver'], info: driver },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Update ${driver.name} Failed`,
      error,
    })
  }
})
